"use client";

import { useEffect, useState, type ReactNode } from "react";
import { getOrCreateAppKit } from "@/config/web3modal";

interface Web3ModalProviderProps {
  children: ReactNode;
}

/**
 * Provider component that initializes AppKit/Web3Modal.
 * This is separate from Privy and used only for wallet linking by email users.
 */
export function Web3ModalProvider({ children }: Web3ModalProviderProps) {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Initialize AppKit on mount (client-side only)
    getOrCreateAppKit();
    setIsReady(true);
  }, []);

  if (!isReady) return null;

  return <>{children}</>;
}
